var _rect, _text, _rect2, _text2, _line, _polygon, _rect3, _text3, _text4, _line2, _polygon2, _rect4, _text5, _text6, _line3, _line4, _line5, _line6, _rect5, _text7, _text8, _text9, _rect6, _text10, _text11, _text12, _rect7, _text13, _text14, _text15, _rect8, _text16, _text17, _text18, _line7, _line8, _line9, _line10, _rect9, _text19, _text20, _text21, _text22, _line11, _line12, _line13, _rect10, _text23, _rect11, _text24, _rect12, _text25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentGovernance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "govBoxGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111111",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    rx: 8,
    fill: "#0C0C0C",
    stroke: "#DCCA87",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 36,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "#DCCA87",
    letterSpacing: 2,
    opacity: 0.7
  }, "GOVERNANCE ENFORCEMENT \u2014 TOOL-CALL BOUNDARY")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 56,
    width: 200,
    height: 38,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 79,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Agent Runtime")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 94,
    x2: 400,
    y2: 118,
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "396,118 400,125 404,118",
    fill: "#DCCA87",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 126,
    width: 240,
    height: 44,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 145,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    letterSpacing: 1,
    opacity: 0.7
  }, "ENFORCEMENT BOUNDARY")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 162,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Tool Call Interceptor")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 170,
    x2: 400,
    y2: 198,
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "396,198 400,205 404,198",
    fill: "#DCCA87",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 206,
    width: 260,
    height: 44,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 225,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    letterSpacing: 1,
    opacity: 0.7
  }, "REAL-TIME EVALUATION")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 242,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Policy Engine")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 250,
    x2: 140,
    y2: 290,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 250,
    x2: 320,
    y2: 290,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 250,
    x2: 480,
    y2: 290,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 490,
    y1: 250,
    x2: 650,
    y2: 290,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 292,
    width: 140,
    height: 60,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.25,
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 314,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Loop Detection")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 332,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "recursive self-delegation")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 346,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "cycle depth \xB7 token velocity")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 292,
    width: 140,
    height: 60,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.25,
    strokeWidth: 1
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 314,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Scope Enforcement")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 332,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "mandate boundary check")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 346,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "tool whitelist \xB7 data access")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 292,
    width: 140,
    height: 60,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.25,
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 314,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Handoff Policy")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 332,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "multi-model routing")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 346,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "cost tier \xB7 capability gate")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 292,
    width: 140,
    height: 60,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.25,
    strokeWidth: 1
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 314,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Explainability")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 332,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "decision audit trail")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 346,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "why \xB7 what-if \xB7 provenance")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 352,
    x2: 320,
    y2: 395,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 310,
    y1: 352,
    x2: 360,
    y2: 395,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 352,
    x2: 440,
    y2: 395,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 650,
    y1: 352,
    x2: 480,
    y2: 395,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 396,
    width: 200,
    height: 50,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 418,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    letterSpacing: 1,
    opacity: 0.7
  }, "GOVERNANCE DECISION")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 438,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#4CAF50"
  }, "ALLOW")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 438,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#FFC107"
  }, "CONSTRAIN")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 465,
    y: 438,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#F44336"
  }, "HALT")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 446,
    x2: 280,
    y2: 472,
    stroke: "#4CAF50",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 446,
    x2: 400,
    y2: 472,
    stroke: "#FFC107",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 465,
    y1: 446,
    x2: 520,
    y2: 472,
    stroke: "#F44336",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 475,
    width: 100,
    height: 26,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#4CAF50",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 492,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#4CAF50"
  }, "Execute Tool")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 475,
    width: 100,
    height: 26,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#FFC107",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 492,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#FFC107"
  }, "Downgrade Model")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 475,
    width: 100,
    height: 26,
    rx: 4,
    fill: "url(#govBoxGrad)",
    stroke: "#F44336",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 492,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#F44336"
  }, "Kill Session")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentGovernance);
export default __webpack_public_path__ + "static/media/agent-governance.1002f412fc21b5af209adb1081a9cc6f.svg";
export { ForwardRef as ReactComponent };